module.exports = __webpack_public_path__ + "img/fr.a11583f8.png";